<template>
    <div class="collapsible ">
        <div class="trigger">
            <div class="row align-items-center">
                <div class="col-auto">
                    <div class="trigger-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                </div>
                <div class="col">
                    <div class="trigger-content">Alertas</div>
                </div>
                <!--<div class="col-auto">
                    <div class="trigger-indicator">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    </div>
                </div>-->
            </div>
        </div>
        <div class="body show">
            <div class="card alerta-card touchpad" @click="goToAlerts(alerta.index)" v-for="alerta in alertas" :key="alerta.id">
                <div class="card-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-auto content-col">
                                <font-awesome-icon :icon="alerta.icon" style="color:#00B99E"/>
                            </div>
                            <div class="col-auto content-col">
                                <p class="paragraph touchpad"> {{alerta.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

library.add(faEnvelope);

export default {
    name: 'alertas',
    data () {
        return {
            alertas:[
                {
                    index:1,
                    name:'Correo Electrónico',
                    id:'email',
                    icon:'envelope'
                },
                /*{
                    index:2,
                    name:'SMS',
                    id:'sms'
                },
                {
                    index:3,
                    name:'Push Notification',
                    id:'push'
                }*/
                
            ]
        }
    },
    methods:{
        goToAlerts(id){
            console.log(id);
            switch(id){
                case 1: this.$router.push('/emails'); break;
                /*case 2: this.$router.push('/sms'); break;
                case 3: this.$router.push('/push'); break;*/
            }
        }
    }
}
</script>

<style>
.alerta-card:hover{
background: #ebf9ff!important;
}
</style>